__turbopack_context__.v({
  "content": "Select-module__xItvXq__content",
  "control": "Select-module__xItvXq__control",
  "icon": "Select-module__xItvXq__icon",
  "item": "Select-module__xItvXq__item",
  "label": "Select-module__xItvXq__label",
  "value": "Select-module__xItvXq__value",
});
